import React from 'react';
import { FiX } from 'react-icons/fi';

const DrilldownModal = ({ isOpen, onClose, data }) => {
  if (!isOpen || !data) return null;

  const renderContent = () => {
    switch (data.type) {
      case 'activeJob':
        return (
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <span className={`px-3 py-1 rounded-lg text-sm font-medium ${
                data.data?.status === 'Active' ? 'bg-blue-100 text-blue-900' :
                data.data?.status === 'Urgent' ? 'bg-red-100 text-red-900' :
                data.data?.status === 'Pending' ? 'bg-yellow-100 text-yellow-900' :
                'bg-gray-100 text-gray-700'
              }`}>
                {data.data?.status}
              </span>
            </div>
            <h3 className="text-xl font-bold text-gray-900">{data.data?.title}</h3>
            <p className="text-gray-600">{data.data?.description}</p>
            <div className="border-t pt-4 mt-4">
              <h4 className="font-semibold text-gray-900 mb-3">Job Details</h4>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-500">Job ID</p>
                  <p className="font-medium">{data.data?.id || 'N/A'}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Created Date</p>
                  <p className="font-medium">{data.data?.created || 'N/A'}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Location</p>
                  <p className="font-medium">{data.data?.location || 'Remote'}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Client</p>
                  <p className="font-medium">{data.data?.client || 'N/A'}</p>
                </div>
              </div>
            </div>
          </div>
        );

      case 'donutChart':
        return (
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-gray-900">{data.title}</h3>
            <div className="space-y-3">
              {data.data?.map((item, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                  <div className="flex items-center gap-3">
                    <span
                      className="w-4 h-4 rounded-full"
                      style={{ backgroundColor: item.color }}
                    />
                    <span className="font-medium">{item.name}</span>
                  </div>
                  <span className="text-lg font-bold">{item.value}</span>
                </div>
              ))}
            </div>
          </div>
        );

      case 'listItem':
        return (
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-gray-900">{data.data?.name}</h3>
            <p className="text-gray-600">{data.data?.subtitle}</p>
            <div className="border-t pt-4 mt-4">
              <h4 className="font-semibold text-gray-900 mb-3">Details</h4>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-500">Total Jobs</p>
                  <p className="font-medium text-2xl">{data.data?.value}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Category</p>
                  <p className="font-medium">{data.data?.subtitle || 'N/A'}</p>
                </div>
              </div>
            </div>
          </div>
        );

      case 'listViewAll':
        return (
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-gray-900">{data.title} - All Items</h3>
            <div className="space-y-2 max-h-96 overflow-y-auto">
              {data.data?.map((item, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-primary-700 font-medium text-sm">
                        {item.name?.charAt(0)?.toUpperCase()}
                      </span>
                    </div>
                    <div>
                      <p className="font-medium">{item.name}</p>
                      <p className="text-xs text-gray-500">{item.subtitle}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="font-semibold">{item.value}</p>
                    <p className="text-xs text-gray-500">{item.subValue}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );

      case 'progressItem':
        return (
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-gray-900">{data.data?.name}</h3>
            <div className="w-full bg-gray-200 rounded-full h-4">
              <div
                className="h-4 rounded-full"
                style={{
                  width: `${data.data?.value}%`,
                  backgroundColor: data.data?.color,
                }}
              />
            </div>
            <p className="text-gray-600">{data.data?.subtitle}</p>
            <div className="border-t pt-4 mt-4">
              <h4 className="font-semibold text-gray-900 mb-3">Performance Details</h4>
              <div className="text-center">
                <p className="text-4xl font-bold" style={{ color: data.data?.color }}>
                  {data.data?.value}%
                </p>
                <p className="text-gray-500 mt-2">Completion Rate</p>
              </div>
            </div>
          </div>
        );

      case 'progressViewAll':
        return (
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-gray-900">{data.title} - All Progress</h3>
            <div className="space-y-4 max-h-96 overflow-y-auto">
              {data.data?.map((item, index) => (
                <div key={index} className="p-3 bg-gray-50 rounded-lg">
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-medium">{item.name}</span>
                    <span className="font-bold">{item.value}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div
                      className="h-2.5 rounded-full"
                      style={{
                        width: `${item.value}%`,
                        backgroundColor: item.color,
                      }}
                    />
                  </div>
                  <p className="text-xs text-gray-500 mt-1">{item.subtitle}</p>
                </div>
              ))}
            </div>
          </div>
        );

      default:
        return <p className="text-gray-500">No details available</p>;
    }
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
          onClick={onClose}
        />

        {/* Modal */}
        <div className="relative bg-white rounded-xl shadow-xl max-w-lg w-full p-6 transform transition-all">
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <FiX size={20} className="text-gray-500" />
          </button>

          {/* Content */}
          <div className="mt-2">{renderContent()}</div>

          {/* Actions */}
          <div className="mt-6 flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
            >
              Close
            </button>
            <button
              onClick={onClose}
              className="px-4 py-2 text-white bg-primary-600 hover:bg-primary-700 rounded-lg transition-colors"
            >
              View Full Details
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DrilldownModal;
